import React, { useState, useEffect, useCallback } from "react"
import MyModal from "../MyModal"
import Input from "../Input"
import actionHelper from "../../lib/actionHelper"
import { toast } from "react-toastify"
import { createJts3User } from "../../services/jts3Apis"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"

const CreateJts3UserModal = ({ user, isOpen, toggleModal }) => {
    const { isConnected, sendMessage } = useSocket()

    const [price, setPrice] = useState(null)

    const submitHandler = (e) => {
        e.preventDefault()

        const form = new FormData(e.target)

        const data = {
            email: form.get("email"),
            username: form.get("username"),
            password: form.get("password"),
            information: form.get("information"),
        }
        actionHelper({
            confirmation: {
                label: `مقدار ${price} از حساب شما کم میشود`,
                actionLabel: "ساخت کاربر ",
                color: "success",
            },
            callback: () => createJts3User(data),
            texts: {
                success: "کاربر با موفقیت ساخته شد",
                pending: "درحال ساخت کاربر",
            },
        })
    }

    useSocketEvent(
        "jts3Price",
        useCallback((data) => {
            console.log(data)
            setPrice(data)
        }, []),
    )

    useEffect(() => {
        if (isConnected) {
            sendMessage("getJts3Price")
        }
    }, [isConnected])

    return (
        <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="400px">
            <div className="">
                <form onSubmit={submitHandler} className="m-2 ml-2">
                    <div className="mt-2">
                        <Input type="text" name="email" label="ایمیل" placeholder="ایمیل" required={true} />
                    </div>
                    <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <Input type="text" dir="ltr" label={"نام کاربری"} placeholder={"Username"} name={"username"} />

                        <Input
                            type="password"
                            dir="ltr"
                            min={8}
                            max={30}
                            label={"پسورد"}
                            placeholder={"Password"}
                            name={"password"}
                        />
                    </div>

                    <span id="rsPriceLabel">
                        <div class="show_info text-sm mt-2 text-green-400">{price?.toLocaleString("en-US")} تومان</div>
                    </span>

                    <Input type="text" dir="rtl" label={"توضیحات"} placeholder={"توضیحات"} name={"information"} />

                    <button type="submit" className="styled-button w-full mt-5">
                        ساخت کاربر JTS3
                    </button>
                </form>
            </div>
        </MyModal>
    )
}

export default CreateJts3UserModal
